import {
  FilterType,
  buildTrainingRequestsDatatableFilter,
  useTrainingRequestsDatatable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

export const dateFilter = (source: ReturnType<typeof useTrainingRequestsDatatable>) => {
  return buildTrainingRequestsDatatableFilter(source, {
    identifier: 'dateFilter',
    title: i18n.t('trainings.training_requests.requests.datatable.filters.date'),
    path: 'createdAt',
    default: true,
    type: FilterType.Date,
    categories: [
      {
        kind: 'DatePicker',
        operation: 'between',
      },
    ],
  })
}
